

























































































































import { Component } from "vue-property-decorator";
import { dateFilter, timeFilter } from "@/utils/date-util";
import { CallGroupIncomingItem, CallGroupIncomingSummary } from "@/store/call/statistic/types";
import BaseItemsPage from "../BaseItemsPage";
import CallGroupIncomingFilter from "@/components/Call/Statistic/CallGroupIncomingFilter.vue";
import { ScrollButton } from "wings-ui-components";
import { Getter } from "vuex-class";
import GroupCharts from "@/components/Statistics/GroupCharts.vue";

@Component({
  components: {CallGroupIncomingFilter, ScrollButton, GroupCharts},
  filters: {dateFilter, timeFilter},
})
export default class CallGroupIncoming extends BaseItemsPage<CallGroupIncomingItem> {

  @Getter("callStatisticGroupIncoming") responseItems?: CallGroupIncomingItem[];
  @Getter("callStatisticGroupIncomingSummary") responseSummary?: CallGroupIncomingSummary;
  @Getter("callGroupByIncoming") groupByList: any;

  is_show_filter: boolean = true;
  is_show_graphics: boolean = true;
  currentSort: string = "date";

  tableFields: string[] = this.tableFieldsDefault;

  group_by: string = '';
  optionally_group_by: string = '';

  onGroupByChange(groupBy: string, optionallyGroupBy: string) {
    this.group_by = groupBy
    this.optionally_group_by = optionallyGroupBy
  }

  getData(): CallGroupIncomingItem[] | undefined {
    return this.responseItems;
  }

  get tableFieldsDefault(): string[] {
    return ['finished', 'error', 'total', 'duration'];
  }

  get totalData(): CallGroupIncomingSummary & { totalRow: string } {
    if (this.responseSummary) {
      return {
        totalRow: 'This is the last row of the table',
        finished: this.responseSummary.finished || 0,
        error: this.responseSummary.error || 0,
        total: this.responseSummary.total || 0,
        duration: this.responseSummary.duration || '00:00:00',
      };
    }
    return {
      totalRow: 'This is the last row of the table',
      finished: 0,
      error: 0,
      total: 0,
      duration: '00:00:00',
    };
  }

  get compareData() {
    return [...this.queriedData, this.totalData];
  }

  itemColor(item: CallGroupIncomingItem){
    if (item.finished / item.total * 100 < 50) return 'color-danger';
    if (item.finished / item.total * 100 < 85) return 'color-warning';
    if (item.finished / item.total * 100 < 100) return 'color-success';
    return 'color-success'
  }
}
